import React, { useContext, useState, useEffect } from 'react';
import { Label, Alert, Input, Select, SelectOption } from '@americanexpress/dls-react';
import UserContext from '../ContextComponent/UserContext';
import { CONSTANTS } from '../../constants';

function Address({ type, descr, label, className, required }) {
    const [InvalidPincode, setInvalidPincodeError] = useState(false);
    const [AddressLine1PatternError, setAddressLine1PatternError] = useState(false);
    const [AddressLine2PatternError, setAddressLine2PatternError] = useState(false);
    const [AddressLine3PatternError, setAddressLine3PatternError] = useState(false);
    const { formData, setFormData } = useContext(UserContext);
    const { errorData, setErrorData } = useContext(UserContext);
    const [address1Required, setAddress1Required] = useState(false);
    const [address2Required, setAddress2Required] = useState(false);
    const [address3Required, setAddress3Required] = useState(false);
    const [cityStateReadOnly, setCityStateReadOnly] = useState(true);
    const [stateList, setStateList] = useState([]);

    useEffect(() => {
        getStateList();        
    }, []);
    const pinBlurHandler = async (e) => {
        if (e.target.value === '') {
            setErrorData({ ...errorData, CompanyAddressPincodeRequired: true });
        }


        else {
            setErrorData({ ...errorData, CompanyAddressPincodeRequired: false });
        }
        setInvalidPincodeError(false);

        try {
            await fetch(`/apply/resources/pin-code-by-city-state?pincode`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(e.target.value)
                })
                .then(response => response.json())
                .then(result => {
                    setFormData({ ...formData, city: result.cityName, CompanyAddressPincode: result.pincode, companyAddressCity: result.cityName, companyAddressState: result.stateCode, CompanyAddressStateName: result.stateName })
                    return result
                }).then(json => json).then(result => {
                    setCityStateReadOnly(true);
                })
        }
        catch {
            setCityStateReadOnly(false);
        }
    }
    const pinChangeHandler = (e) => {
        setFormData({ ...formData, CompanyAddressPincode: e.target.value })
        const patternresult = !CONSTANTS.validation.pinPattern.test(e.target.value);
        setInvalidPincodeError(patternresult);
    }
    const addressLine1BlurHandler = (event) => {
        var newVal = event.target.value.replace(/ +(?= )/g, '').trim();
        newVal = newVal.replace('\t',' ').replace('\n', ' ').replace('\r', ' ');
        setFormData({ ...formData, OfficeAddressLine1:  newVal });
        event.target.value = newVal;
     
        if (event.target.value === '' || event.target.value.length < 3) {
            setErrorData({ ...errorData, OfficeAddressLine1Required: true });
            setAddressLine1PatternError(true);
        }
        else if (event.target.value.length >= 3) {
            const patternresult = !CONSTANTS.validation.addressPattern.test(event.target.value);
            setAddressLine1PatternError(patternresult);
            setErrorData({ ...errorData, OfficeAddressLine1Required: false });
            if (patternresult) {
                setErrorData({ ...errorData, OfficeAddressLine1Required: true });
            }
        }
    }
    const addressLine2BlurHandler = (event) => {
        var newVal = event.target.value.replace(/ +(?= )/g, '').trim();
        newVal = newVal.replace('\t',' ').replace('\n', ' ').replace('\r', ' ');
        setFormData({ ...formData, OfficeAddressLine2: newVal });
        event.target.value = newVal;

        if (event.target.value === '') {
            setErrorData({ ...errorData, OfficeAddressLine2Required: true });
            setAddressLine2PatternError(true);
        }
        else if (event.target.value.length >= 1) {
            const patternresult = !CONSTANTS.validation.addressPattern.test(event.target.value);
            setAddressLine2PatternError(patternresult);
            setErrorData({ ...errorData, OfficeAddressLine2Required: false });
            if (patternresult) {
                setErrorData({ ...errorData, OfficeAddressLine2Required: true });
            }
        }
    }
    const addressLine3BlurHandler = (event) => {

        var newVal = event.target.value.replace(/ +(?= )/g, '').trim();
        newVal = newVal.replace('\t',' ').replace('\n', ' ').replace('\r', ' ');
        setFormData({ ...formData, OfficeAddressLine3: newVal });
        event.target.value = newVal;

        if (event.target.value === '') {
            setErrorData({ ...errorData, OfficeAddressLine3Required: true });
            setAddressLine3PatternError(true);
        }
        else if (event.target.value.length >= 1) {
            const patternresult = !CONSTANTS.validation.addressPattern.test(event.target.value);
            setAddressLine3PatternError(patternresult);
            setErrorData({ ...errorData, OfficeAddressLine3Required: false });
            if (patternresult) {
                setErrorData({ ...errorData, OfficeAddressLine3Required: true });
            }
        }
    }
    const pinKeyPressHandler = (e) => {
        if (!CONSTANTS.validation.pinPattern.test(e.key)) {
            e.preventDefault();
        }
    }
    const maxLengthCheck = (object) => {
        if (object.target.value.length > object.target.maxLength) {
            object.target.value = object.target.value.slice(0, object.target.maxLength);
        }
    }
    const blurCityHandler = (e) => {
        setFormData({ ...formData, companyAddressCity: document.getElementById(`${type}City`).value });
        if (e.target.value.length > 1) {            
            setErrorData({ ...errorData, companyAddressCityRequired: false });
        }
        else {
            setErrorData({ ...errorData, companyAddressCityRequired: true });
        }
    }
    const cityKeyPressHandler = (e) => {        
        if (!CONSTANTS.validation.cityPattern.test(e.key)) {
            e.preventDefault();
        }
    }
    const getStateList = async () => {
        const result = await fetch(`/api/Location/States`)
            .then(response => response.json())
            .then(json => json);
        setStateList(result);
    }
    const blurStateHandler = (e) => {
        setFormData({
            ...formData,
            CompanyAddressStateName: document.getElementById(`${type}State`).selectedOptions[0].text,
            companyAddressState: e.target.value
        })
        if (e.target.value.length > 1) {
            
            setErrorData({ ...errorData, companyAddressStateRequired: false });
        } else {
                setErrorData({ ...errorData, companyAddressStateRequired: true });            
        }
    }
    return (
        <>
            <div>
                <fieldset>
                    <div className="row pad-1-b">
                        <div className="col-md-6">
                            <Label className="label-1" htmlFor={`${type}Line1`}>{`${descr}`} Address Line 1</Label>
                            <Input
                                id={`${type}Line1`}
                                name={`${type}Line1`}
                                aria-describedby={`${type}Line1Alert`}
                                value={formData.OfficeAddressLine1}
                                required={required === 'true'}
                                onChange={(e) => setFormData({ ...formData, OfficeAddressLine1: e.target.value})}
                                onBlur={addressLine1BlurHandler}
                                maxLength={35}
                            />
                            {errorData.OfficeAddressLine1Required && (
                                <> <Alert id={`${type}Line1Alert`} show={address1Required}>Please provide your {`${descr}`} address line1. </Alert>
                                    <> <Alert id="AddressPattern1-alert" show={AddressLine1PatternError}>Please ensure {`${descr}`} address contains only letters (A-Z, upper and lower case), digits (0-9), spaces, commas, colon, forward slash, single quotes and hyphens with minimum length of 3 characters. Address may not begin with a special character or have consecutive special characters.</Alert></>
                                </>
                            )}
                        </div>
                        <div className="col-md-6">
                            <Label className="label-1" htmlFor={`${type}Line2`}>{`${descr}`} Address Line 2</Label>
                            <Input
                                id={`${type}Line2`}
                                name={`${type}Line2`}
                                required={required === 'true'}
                                value={formData.OfficeAddressLine2}
                                onChange={(e) => setFormData({ ...formData, OfficeAddressLine2: e.target.value })}
                                onBlur={addressLine2BlurHandler}
                                maxLength={35}
                            />
                            {errorData.OfficeAddressLine2Required && (
                                <><Alert id="AddressNull2-alert" show={address2Required}>Please provide your {`${descr}`} address line2. </Alert>
                                    <>
                                        <Alert id="AddressPattern2-alert" show={AddressLine2PatternError}>Please ensure {`${descr}`} address contains only letters (A-Z, upper and lower case), digits (0-9), spaces, commas, colon, forward slash, single quotes and hyphens. Address may not begin with a special character or have consecutive special characters.</Alert>
                                    </>
                                </>
                            )}
                        </div>
                    </div>
                    <div className="row pad-1-b">
                        <div className="col-md-6">
                            <Label className="label-1" htmlFor={`${type}Line3`}>{`${descr}`} Address Line 3</Label>
                            <Input
                                id={`${type}Line3`}
                                name={`${type}Line3`}
                                aria-describedby={`${type}Line3Alert`}
                                value={formData.OfficeAddressLine3}
                                onChange={(e) => setFormData({ ...formData, OfficeAddressLine3: e.target.value })}
                                onBlur={addressLine3BlurHandler}
                                maxLength={35}
                            />
                            {errorData.OfficeAddressLine3Required && (
                                <><Alert id="AddressNull3-alert" show={address3Required}>Please provide your {`${descr}`} address line3. </Alert>
                                    <>
                                        <Alert id="AddressPattern3-alert" show={AddressLine3PatternError}>Please ensure {`${descr}`} address contains only letters (A-Z, upper and lower case), digits (0-9), spaces, commas, colon, forward slash, single quotes and hyphens. Address may not begin with a special character or have consecutive special characters.</Alert>
                                    </>
                                </>
                            )}
                        </div>
                        <div className="col-md-6">
                            <Label className="label-1" htmlFor={`${type}PinCode`}>Pincode</Label>
                            <Input
                                id={`${type}PinCode`}
                                name={`${type}PinCode`}
                                aria-describedby={`${type}pinCodeAlert`}
                                maxLength="6" onInput={maxLengthCheck}
                                onKeyPress={pinKeyPressHandler}
                                value={formData.CompanyAddressPincode}
                                onBlur={(e) => pinBlurHandler(e)}
                                onChange={pinChangeHandler} />
                            <Alert id="AddressNullpin-alert" show={errorData.CompanyAddressPincodeRequired}>Please enter your pincode</Alert>
                            {InvalidPincode && (
                                <Alert id={`${type}invalidPinCodeAlert`} show={true}>Please Enter Valid Pincode</Alert>
                            )}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <Label className="label-1" htmlFor={`${type}City`}>City</Label>
                            <Input id={`${type}City`} name={`${type}City`}
                                readOnly={cityStateReadOnly}
                                onChange={(e) => setFormData({ ...formData, companyAddressCity: e.target.value })}
                                value={formData.companyAddressCity}
                                onBlur={blurCityHandler}
                                maxLength={20}
                                onKeyPress={cityKeyPressHandler}
                            />
                            {errorData.companyAddressCityRequired && (
                                <Alert id="city-alert" show={errorData.companyAddressCityRequired}>Please enter city</Alert>)}
                        </div>
                        <div className="col-md-6">
                            <Label className="label-1" htmlFor={`${type}State`}>State</Label>
                            <Select id={`${type}State`} name={`${type}State`}                               
                                aria-labelledby={`${type}-label ${type}-alert`}
                                fluid={true}
                                value={formData.companyAddressState}
                                disabled={cityStateReadOnly}
                                onChange={(e) => setFormData({ ...formData, companyAddressState: e.target.value })}
                                onBlur={blurStateHandler}
                            >
                                {stateList.map((data, index) => (
                                    <SelectOption key={index} value={data.stateCode}>{data.stateName}</SelectOption>
                                )
                                )}
                            </Select>
                            {errorData.companyAddressStateRequired && (
                                <Alert id="state-alert" show={errorData.companyAddressStateRequired}>Please enter state</Alert>)}
                        </div>
                    </div>
                </fieldset>

            </div>
        </>
    );
}

export default Address;